/**
 * Create an opaque public-form retry key without making form availability
 * depend on `crypto.randomUUID` support. Older clients may omit the key; the
 * server then accepts the submission without deduping on guessable PII.
 */
export function getOrCreatePublicFormSubmissionId(
  current: string | null,
): string | null {
  if (current) return current;

  const cryptoApi = globalThis.crypto;
  if (!cryptoApi) return null;
  try {
    if (typeof cryptoApi.randomUUID === "function") {
      return cryptoApi.randomUUID();
    }
    if (typeof cryptoApi.getRandomValues !== "function") return null;
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;
    const hex = Array.from(bytes, (value) =>
      value.toString(16).padStart(2, "0"),
    ).join("");
    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20),
    ].join("-");
  } catch {
    return null;
  }
}
